import { UnleashClient } from 'unleash-proxy-client'

import sentry from 'legacy/utils/sentry'

import { UNLEASH_CLIENT_KEY } from '../../infra/environment'
import { type ConfigName } from '../domain/Config'
import {
  type RemoteConfigAdapter,
  type RemoteConfigContext,
  type RemoteConfigEvent,
} from '../domain/RemoteConfig'

const UNLEASH_URL = 'https://unleash.loadsmart.com/api/frontend/'
const UNLEASH_APP_NAME = 'carrier-web'

export class UnleashAdapter implements RemoteConfigAdapter {
  private static client?: UnleashClient

  static setup() {
    if (UnleashAdapter.client) return

    UnleashAdapter.client = new UnleashClient({
      url: UNLEASH_URL,
      appName: UNLEASH_APP_NAME,
      clientKey: UNLEASH_CLIENT_KEY,
      refreshInterval: 5 * 60, // 5 minutes
    })
  }

  async init() {
    if (this.ready) return
    try {
      await UnleashAdapter.client?.start()
    } catch (error) {
      sentry.log(error, { level: 'warning' })
    }
  }

  getConfig(config: ConfigName) {
    if (!this.ready) return false
    return UnleashAdapter.client!.isEnabled(config)
  }

  subscribe(event: RemoteConfigEvent, listener: () => void) {
    UnleashAdapter.client?.on(event, listener)
    return () => {
      UnleashAdapter.client?.off(event, listener)
    }
  }

  get ready() {
    return UnleashAdapter.client?.isReady() ?? false
  }

  setContext(context: RemoteConfigContext) {
    return UnleashAdapter.client?.updateContext(context)
  }
}
